import { render, staticRenderFns } from "./ReworksNavigationDrawer.vue?vue&type=template&id=315ea696"
import script from "./ReworksNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./ReworksNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports